import axios from 'axios'
import { authService } from '../auth/AuthService'

const identityApiClient = axios.create({
  baseURL: import.meta.env.VITE_IDENTITY_AUTHORITY,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// Request interceptor to add Authorization header
identityApiClient.interceptors.request.use(config => {
  const token = authService.getAccessToken()
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

export default identityApiClient
